module.exports = __webpack_public_path__ + "img/camera.7db59960.svg";